//import { toggleDropDown, filterDropDown, getSelectedOption } from '../dropdown';
import { displayTerminals } from '../widgets/cg-terminal-widget';
import { terminalListWidget } from '../widgets/terminal-list-widget';
import { displayTaxes } from '../widgets/tax-cg-terminal-widget';
import { taxListWidget } from '../widgets/tax-list-widget';
import { displayLinkedPartnerCustomer } from '../widgets/partner-customer-widget';
import { getParameters } from '../../helpers/helpers';
import { LINK_CG_TERMINAL_FORM, LINK_CG_TERM_TAX_FORM } from './terminalCardGroup/form-tcg-types';
import { TERMINAL_DEFAULT_TAX } from './terminalTax/form-terminal-tax-types';

import { addCardGroupTerminal } from './terminalCardGroup/linkCardGroupTerminal/add-cardgroup-terminal';
import { addTaxCardGroupTerminal } from './terminalCardGroup/linlkTaxCardGroupTerminal/add-tax-cardgroup-terminal';
import { addTerminalTax } from './terminalTax/add-terminal-tax';

const checkForSelectValue = (dataEle: any, message: string, eleNum: string) => {
  let err = document.querySelector('.dropdown-error-' + eleNum) as HTMLElement;
  let dropContain = document.querySelector('.aafp_dropdown-container-' + eleNum) as HTMLElement;;

  if(!dataEle.hasAttribute('data-value')) {
    dropContain.classList.remove('drop-valid');
    err!.innerText = `Please select a ${message}`;
    dropContain.classList.add('drop-error');
  } else {
    err!.innerText = '';
    dropContain.classList.remove('drop-error');
  }
}

/**
 * Get selection from availiable list and moves it to the selected list
 * 
 * @param {string} filterElems elements to be filtered in list
 * @param {string} resultsContainer container to display selected results
 */

export const getSelectionFromAvailableList = (filterElems: string, resultsContainer: string, cardType?: string) => {
  let elems = document.querySelectorAll<HTMLElement>(filterElems);
  let con = document.querySelector(resultsContainer) as HTMLElement;
  let customerId = getParameters('customerId');
  let cardGroupId = getParameters('cardGroupID');
  let terminalID = getParameters('tID');
  let cardGroupID = getParameters('cgID');
  let data: Array<any> = [];

  elems.forEach((item: any) => {
    item.addEventListener('click', () => {
      if ( cardType === 'terminal') {        
        data.push({ termId: item.dataset.id!, termName: item.dataset.name!, partnerName: item.dataset.partnername, partnerId: item.dataset.partner, displayTax: '' });        
        displayTerminals(data, customerId, cardGroupId, item.dataset.partner!, con);
        addCardGroupTerminal( cardGroupId );
      } else if ( cardType === 'tax' ) {
        data.push({ taxId: item.dataset.id, taxName: item.dataset.name, taxRate: item.dataset.rate });
        displayTaxes(data, con);
        addTaxCardGroupTerminal(cardGroupID, terminalID);
      } else if ( cardType === 'partner') {
        data.push({ id: item.dataset.id, name: item.dataset.name });  
        displayLinkedPartnerCustomer(con, data);
      }
      item.parentElement!.remove();
    });
  });
} 

/**
 * Get selection from selected list and moves it to the availiable list
 * 
 * @param {string} filterElems elements to be filtered in list
 * @param {string} resultsContainer container to display selected results
 */

export const getSelectionFromLinkedList = (filterElems: string, resultsContainer: string) => {
  let elems = document.querySelectorAll<HTMLElement>(filterElems);
  let con = document.querySelector(resultsContainer) as HTMLElement;

  for(let i = 0; i < elems.length; i++) {
    elems[i].addEventListener('click', () => {
      let parentEle = document.querySelector('.key_' + elems[i].dataset.id) as HTMLElement;
      parentEle?.style.setProperty('display', 'flex', 'important');
      let removeEle = document.querySelector('.cg_access_' + elems[i].dataset.id);
      removeEle?.remove();
    });
  }
}

/**
 * Function to remove an item from the linked list
 * 
 * @param {string} accessElement element to target
 * @param {any} id unique id for the element
 */
const removeFromLinkedList = (accessElement: string, id: any) => {
  let getAccessList = document.querySelector(accessElement) as HTMLElement;
  let removeEle = document.querySelector('.cg_access_' + id);
  let cardGroupId = getParameters('cardGroupID');
  let elementData: Array<any> = [];

  elementData.push({
    terminalId: removeEle?.getAttribute('data-termid'),
    terminalName: removeEle?.getAttribute('data-name'),
    partnerId: removeEle?.getAttribute('data-partner'),
    partnerName: removeEle?.getAttribute('data-partnername')
  });

  if(!getAccessList) return;
  getAccessList.addEventListener('click', () => {    
    removeEle?.remove(); 
    terminalListWidget( elementData, LINK_CG_TERMINAL_FORM.searchResults );
    addCardGroupTerminal( cardGroupId );       
  });
}

/**
 * Function to remove an item from the linked list
 * 
 * @param {string} accessElement element to target
 * @param {any} id unique id for the element
 */
const removeFromTaxLinkedList = (accessElement: string, id: any) => {
  let getAccessList = document.querySelector(accessElement) as HTMLElement;
  let removeEle = document.querySelector('.cg_access_' + id);
  let terminalID = getParameters('tID');
  let cardGroupID = getParameters('cgID');
  let elementData: Array<any> = [];

  elementData.push({
    taxId: removeEle?.getAttribute('data-taxid'),
    taxName: removeEle?.getAttribute('data-name'),
    taxRate: removeEle?.getAttribute('data-rate'),
  });

  if(!getAccessList) return;
  getAccessList.addEventListener('click', () => {    
    taxListWidget( elementData, LINK_CG_TERM_TAX_FORM.cgTTsearchResults );
    removeEle?.remove();
    addTaxCardGroupTerminal(cardGroupID, terminalID);
  });
}

/**
 * Function to remove an item from the linked list
 * 
 * @param {string} accessElement element to target
 * @param {any} id unique id for the element
 */
const removeTerminalDefaultTax = (accessElement: string, id: any) => {
  let getAccessList = document.querySelector(accessElement) as HTMLElement;
  let removeEle = document.querySelector('.cg_access_' + id);
  let terminalID = getParameters('terminalID');
  let elementData: Array<any> = [];

  elementData.push({
    taxId: removeEle?.getAttribute('data-taxid'),
    taxName: removeEle?.getAttribute('data-name'),
    taxRate: removeEle?.getAttribute('data-rate'),
  });

  if(!getAccessList) return;
  getAccessList.addEventListener('click', () => {    
    taxListWidget( elementData, TERMINAL_DEFAULT_TAX.searchResults );
    removeEle?.remove();
    addTerminalTax(terminalID);
    let defaultMsg = document.querySelector('.no-tax-list') as HTMLElement;
    if ( defaultMsg ) {
      defaultMsg.remove();
    }
  });
}

export { checkForSelectValue, removeFromLinkedList, removeFromTaxLinkedList, removeTerminalDefaultTax };